import { createElement } from "../utils/dom.js";
import { createIcon } from "./icons.js";
import { BUTTON_SIZES } from "../config/index.js";

/**
 * Create the feedback button
 * @param {Object} config - Button configuration
 * @returns {HTMLElement} Button element
 */
export function createButton(config) {
    const {
        buttonText,
        buttonIcon,
        buttonSize,
        primaryColor,
        animated,
        widgetStyle,
    } = config;
    const buttonConfig = BUTTON_SIZES[buttonSize] || BUTTON_SIZES.medium;
    let iconColor = "#fff";
    if (widgetStyle === "minimal") {
        iconColor = primaryColor;
    }

    const button = createElement(
        "button",
        `feedback-button button-${buttonSize}`,
        {
            "aria-label": "Open feedback form",
            style: `
      background-color: ${primaryColor}; 
      padding: ${buttonConfig.padding}; 
      font-size: ${buttonConfig.fontSize}; 
      height: ${buttonConfig.height}px; 
      width: ${buttonConfig.width}px;
    `,
        }
    );

    button.innerHTML = createButtonContent(
        buttonIcon,
        buttonText,
        buttonConfig,
        animated,
        iconColor
    );

    return button;
}

/**
 * Create button content HTML
 * @param {string} buttonIcon - Icon type
 * @param {string} buttonText - Button text
 * @param {Object} buttonConfig - Button size configuration
 * @param {boolean} animated - Whether button is animated
 * @returns {string} Button HTML content
 */
function createButtonContent(
    buttonIcon,
    buttonText,
    buttonConfig,
    animated,
    iconColor
) {
    let content = "";

    if (buttonIcon && buttonIcon !== "none") {
        const iconClass = animated ? "button-icon animated" : "button-icon";
        content += `<span class="${iconClass}">${createIcon(
            buttonIcon,
            buttonConfig.iconSize,
            iconColor
        )}</span>`;
    }

    if (buttonText) {
        content += `<span class="button-text">${buttonText}</span>`;
    }

    return content;
}
